import { motion } from 'framer-motion';
import { Button, Stack, Text, Title, Container } from '@mantine/core';
import { IconHome, IconArrowLeft, IconMoodSad } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Container size="md" py="xl">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Stack align="center" gap="xl" ta="center" className="relative">
         

          {/* Icon */}
          <motion.div
            initial={{ scale: 0, rotate: -180 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{ type: "spring", delay: 0.3, stiffness: 150 }}
          >
            <div className="w-32 h-32 rounded-full bg-gradient-to-br from-green-100 to-emerald-100 flex items-center justify-center shadow-lg">
              <IconMoodSad size={64} className="text-green-600" />
            </div>
          </motion.div>

          {/* Title */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <Title order={1} className="text-gray-900 mb-3" size="h2">
              Page Not Found
            </Title>
            <Text size="lg" c="dimmed" className="max-w-md mx-auto">
              Oops! The page you're looking for doesn't exist or has been moved.
            </Text>
          </motion.div>

          {/* Description */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="max-w-lg"
          >
            <Text size="sm" c="dimmed" className="text-gray-500">
              Don't worry, even the best get lost sometimes. Let's get you back on track.
            </Text>
          </motion.div>

          {/* Action Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
          >
            <Stack gap="md" align="center">
              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  size="lg"
                  leftSection={<IconHome size={20} />}
                  onClick={() => navigate('/')}
                  style={{ 
                    backgroundColor: '#699269',
                    height: '48px',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                  }}
                  className="hover:opacity-90"
                >
                  Go Home
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  leftSection={<IconArrowLeft size={20} />}
                  onClick={() => navigate(-1)}
                  style={{ 
                    height: '48px',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                    borderColor: '#699269',
                    color: '#699269',
                  }}
                  className="hover:bg-green-50"
                >
                  Go Back
                </Button>
              </div>
              
              <Text size="xs" c="dimmed" className="text-gray-400 mt-4">
                Still lost? Contact support for assistance.
              </Text>
            </Stack>
          </motion.div>

            {/* Floating Elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none -z-10">
              <motion.div
                animate={{
                  y: [0, -20, 0],
                  rotate: [0, 5, 0],
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
                className="absolute top-20 left-10 w-12 h-12 rounded-full bg-green-100 opacity-30"
              />
              <motion.div
                animate={{
                  y: [0, 20, 0],
                  rotate: [0, -5, 0],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
                className="absolute bottom-20 right-10 w-16 h-16 rounded-full bg-emerald-100 opacity-20"
              />
              <motion.div
                animate={{
                  y: [0, -15, 0],
                }}
                transition={{
                  duration: 3.5,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
                className="absolute top-1/2 right-20 w-8 h-8 rounded-full bg-green-200 opacity-25"
              />
            </div>
          </Stack>
        </motion.div>
      </Container>
    </div>
  );
}

